import { BrowserWindowRef } from '@one/app/shared/classes/browser-window-ref';
import { WindowRef } from '@one/app/shared/classes/window-ref';
import { ClassProvider } from '@angular/core';

export const BROWSER_WINDOW_PROVIDER: ClassProvider = {
  provide: WindowRef,
  useClass: BrowserWindowRef,
};
